import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import exact from 'prop-types-exact'
import { Accordion } from 'react-accessible-accordion'
import { IncomeSectionAccordionItem } from 'components'
import { kebabCase } from 'lodash'
import { HOUSEHOLD_INCOME_SECTIONS } from 'config'

const propTypes = {
  householdMember: Types.householdMember.isRequired,
  fundingProgram: PropTypes.string.isRequired,
  certType: PropTypes.string.isRequired,
  handleSubmitCrud: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(Types.file).isRequired,
  isLoading: PropTypes.bool.isRequired,
  setMembers: PropTypes.func.isRequired,
  setSectionCompletionStatus: PropTypes.func.isRequired,
}

const defaultProps = {}

function IncomeSectionsAccordion({
  householdMember,
  fundingProgram,
  certType,
  isLoading,
  setMembers,
  files,
  handleSubmitCrud,
  setSectionCompletionStatus,
}) {
  const sectionUuids = HOUSEHOLD_INCOME_SECTIONS.map(
    (section) => `${kebabCase(section.header)}-${householdMember.id}`
  )
  const firstSectionUuid = sectionUuids[0]

  const [preExpanded, setPreExpanded] = useState([firstSectionUuid])
  const [accordionKey, setAccordionKey] = useState(0)

  const openNextSection = (currentIndex) => {
    const nextIndex = currentIndex + 1
    if (nextIndex >= sectionUuids.length) return
    setPreExpanded([sectionUuids[nextIndex]])
    setAccordionKey((k) => k + 1)
    // Scroll to the top of the next section after React re-renders
    setTimeout(() => {
      requestAnimationFrame(() => {
        const el = document.getElementById(
          `income-section-${householdMember.id}-${nextIndex}`
        )
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    }, 0)
  }

  return (
    <Accordion
      key={accordionKey}
      className="sections-accordion"
      allowZeroExpanded
      preExpanded={preExpanded}
    >
      {HOUSEHOLD_INCOME_SECTIONS.map((section, index) => (
        <div
          key={section.header}
          id={`income-section-${householdMember.id}-${index}`}
        >
          <IncomeSectionAccordionItem
            stepNumber={String(index + 1).padStart(2, '0')}
            title={section.header}
            data={section}
            uuid={sectionUuids[index]}
            householdMember={householdMember}
            fundingProgram={fundingProgram}
            certType={certType}
            files={files}
            isLoading={isLoading}
            setMembers={setMembers}
            handleSubmitCrud={handleSubmitCrud}
            setSectionCompletionStatus={setSectionCompletionStatus}
            onSaveSuccess={() => openNextSection(index)}
          />
        </div>
      ))}
    </Accordion>
  )
}

IncomeSectionsAccordion.propTypes = exact(propTypes)
IncomeSectionsAccordion.defaultProps = defaultProps

export default React.memo(IncomeSectionsAccordion)
